import messages from 'jquery-validation/dist/localization/messages_fr';

(($) => {
    'use strict'

    const $inputMaxLength = $('[maxlength]:not([type="checkbox"])');
    if ($inputMaxLength.length) {
        $inputMaxLength.maxlength();
    }

    const $formValidator = $('.form-validator');
    if ($formValidator.length === 0) {
        return;
    }

    $.extend($.validator.messages, messages);

    $.validator.addMethod('urlRegex', (value) => {
        if(value === '') { return true; }
        return /^(https?:\/\/|\/)\w+\.[^\s]+$|^\/[^\s]*$/.test(value);
    }, 'Veuillez saisir une URL ou un chemin valide.');

    $.validator.addMethod('required-without-media-blocks', (value) => {
        return ($('#media-blocks-container').find('.row').length > 0 || value.length > 0) ;
    }, 'Ce champ est obligatoire.');

    $.validator.addMethod("atleastonefilled", function(value, element, params) {
        params = params.split(',');
        var field1Value = $("#" + params[0]).val();
        var field2Value = $("#" + params[1]).val();

        // Check if at least one of the fields is not null or empty
        return (field1Value !== null && field1Value !== "") || (field2Value !== null && field2Value !== "");
    }, "At least one of the two fields must be filled.");

    $.validator.setDefaults({
        lang: 'fr',
        submitHandler: function (form) {
            form.submit();
        },
        invalidHandler: function(e, validator){
            if (!validator.errorList.length || !$('.nav-tabs').length) {
                return;
            }

            const firstErrorElement = $(validator.errorList[0].element);
            const tabId = firstErrorElement.closest('.tab-pane').attr('id');
            const correspondingTab = $('[href="#' + tabId + '"]');

            correspondingTab.tab('show');
        },
        errorElement: 'span',
        errorPlacement: function (error, element) {
            const errorPlacement = $(element).data('error-placement');
            error.addClass('invalid-feedback');
            if (errorPlacement) {
                $(error).appendTo($(errorPlacement));
            } else {
                element.parent().append(error);
            }

            const stickyHeaderHeight = 57;
            $('html, body').animate({
                scrollTop: element.offset().top - stickyHeaderHeight
            }, 0);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid').addClass('is-valid');
        },
    });

    window.validator = $formValidator.validate({
        ignore: '.bootstrap-duallistbox-container .filter, .bootstrap-duallistbox-container select, #add-new-row select, #add-new-row input'
    });

})($);
